import { render, staticRenderFns } from "./MyClientProfileModal.vue?vue&type=template&id=3e5edb16&"
import script from "./MyClientProfileModal.vue?vue&type=script&lang=js&"
export * from "./MyClientProfileModal.vue?vue&type=script&lang=js&"
import style0 from "./MyClientProfileModal.vue?vue&type=style&index=0&id=3e5edb16&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports